var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup33597(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28906 6.12891V10.1289L10.4224 12.0622L10.9557 11.2622L8.28906 9.66224V6.12891H7.28906Z",
    fill: "#9C4900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5743 8.79818C12.6748 9.4608 12.6304 10.1373 12.4444 10.7812C12.2583 11.4251 11.9349 12.0209 11.4965 12.5278C11.058 13.0347 10.5149 13.4405 9.90458 13.7174C9.29423 13.9942 8.63113 14.1355 7.96094 14.1315C5.36094 14.1315 3.29427 12.0648 3.29427 9.46484C3.29427 6.86484 5.36094 4.79818 7.96094 4.79818C8.4276 4.79818 8.87427 4.86484 9.29427 4.99151V3.61818C8.8676 3.51818 8.42094 3.46484 7.96094 3.46484C4.6276 3.46484 1.96094 6.13151 1.96094 9.46484C1.96094 12.7982 4.6276 15.4648 7.96094 15.4648C8.80606 15.4684 9.64231 15.2925 10.4145 14.949C11.1866 14.6055 11.8772 14.1021 12.4404 13.4721C13.0037 12.842 13.4269 12.0996 13.6821 11.294C13.9373 10.4883 14.0187 9.63763 13.9209 8.79818H12.5743Z",
    fill: "#9C4900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9583 4.12891V2.12891H12.625V4.12891H10.625V5.46224H12.625V7.46224H13.9583V5.46224H15.9583V4.12891H13.9583Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33597);
export default __webpack_public_path__ + "static/media/Group 33597.54280490d18984bdaf5c9218442866d7.svg";
export { ForwardRef as ReactComponent };